const ITEMS = [
  "SEO-First Builds",
  "B2B Lead Generation",
  "WhatsApp Automation",
  "Location Landing Pages",
  "Conversion Copywriting",
  "Speed Engineering",
  "Blog Growth Systems",
  "Affordable Start",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-line bg-ink py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10" aria-hidden={i >= ITEMS.length}>
            <span className="font-display text-2xl font-medium tracking-tight text-white/25">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-ember/60" />
          </div>
        ))}
      </div>
    </div>
  );
}
